import { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import StructuredSectionEditor from "./StructuredSectionEditor";
import BlockTypePreviewMini from "./BlockTypePreviewMini";

const sectionTypeLabels = {
    encabezado: "Encabezado con título y descripción",
    portada: "Portada con imagen de fondo",
    texto: "Bloque de texto formateado",
    division: "División visual",
    filasDivididas: "Filas con texto e imagen",
    tarjetasImagen: "Galería de imágenes",
    lineaTiempo: "Línea de tiempo",
    acordeon: "Preguntas frecuentes (Acordeón)",
    tarjetasAccion: "Tarjetas con botones de acción",
    carrusel: "Carrusel de imágenes",
    franja: "Franja con imagen de fondo",
    bloqueComercial: "Bloque comercial (dos columnas)",
};

const getSectionTypeLabel = (type) => sectionTypeLabels[type] || type;

const SectionEditorCard = ({
    section,
    index,
    structuredConfig,
    structuredEntries,
    updateSection = () => {},
    removeSection = () => {},
    addStructuredLine = () => {},
    editStructuredLine = () => {},
    cancelEdit = () => {},
    removeStructuredLine = () => {},
    editingIndex = null,
    applySimpleTextFormat = () => {},
    setTextEditorRef = () => {},
}) => {
    const [collapsed, setCollapsed] = useState(true);

    return (
    <article className={`admin-pages-section-card admin-pages-section-card-soft ${collapsed ? "admin-section-collapsed" : ""}`}>
        <span className="admin-section-badge">{section.title || `Sección ${index + 1}`}</span>
        <div className="admin-pages-section-header">
            <div className="admin-section-inline-preview">
                <BlockTypePreviewMini type={section.type} />
            </div>
            <InputText
                value={getSectionTypeLabel(section.type)}
                className="admin-section-type-dropdown"
                readOnly
            />
            <Button
                type="button"
                className="p-button-text p-button p-button-sm"
                icon={`pi pi-chevron-${collapsed ? "down" : "up"}`}
                onClick={() => setCollapsed((prev) => !prev)}
                title={collapsed ? "Expandir" : "Colapsar"}
                aria-label={collapsed ? "Expandir sección" : "Colapsar sección"}
            />
            <Button
                type="button"
                className="p-button-text p-button p-button-sm"
                label="Quitar"
                icon="pi pi-trash"
                onClick={() => removeSection(index)}
            />
        </div>
        <div className="admin-pages-section-body">
        <div className="admin-pages-row">
            <label>Nombre de la sección</label>
            <InputText
                className="admin-pages-field"
                value={section.title || ""}
                onChange={(event) => {
                    const clean = event.target.value.replace(/[^a-zA-ZáéíóúüñÁÉÍÓÚÜÑ0-9\s]/g, "");
                    updateSection(index, { title: clean });
                }}
                placeholder="Escribe un título para esta sección"
            />
        </div>

        {section.type === "encabezado" ? (
            <>
                <div className="admin-pages-row">
                    <label>Subtitulo</label>
                    <InputText className="admin-pages-field" value={section.subtitle || ""} onChange={(event) => updateSection(index, { subtitle: event.target.value })} />
                </div>
                <div className="admin-pages-row">
                    <label>Descripcion</label>
                    <InputTextarea className="admin-pages-field" value={section.description || ""} onChange={(event) => updateSection(index, { description: event.target.value })} />
                </div>
            </>
        ) : null}

        {section.type === "portada" ? (
            <>
                <div className="admin-pages-row">
                    <label>Subtitulo</label>
                    <InputText className="admin-pages-field" value={section.subtitle || ""} onChange={(event) => updateSection(index, { subtitle: event.target.value })} />
                </div>
                <div className="admin-pages-row">
                    <label>Descripcion</label>
                    <InputTextarea className="admin-pages-field" value={section.description || ""} onChange={(event) => updateSection(index, { description: event.target.value })} />
                </div>
                <div className="admin-pages-row">
                    <label>Imagen de fondo</label>
                    <InputText
                        className="admin-pages-field"
                        value={section.backgroundImage || ""}
                        onChange={(event) => updateSection(index, { backgroundImage: event.target.value })}
                        placeholder="https://..."
                    />
                    <small className="admin-sidebar-hint admin-text-xs">
                        <i className="pi pi-info-circle" /> Sugerencia: 1920×620px (relación ~3:1). Formato horizontal amplio, cubre todo el ancho con recorte vertical dinámico.
                    </small>
                </div>
            </>
        ) : null}

        {section.type === "texto" ? (
            <div className="admin-pages-row">
                <label>Editor de texto</label>
                <div className="admin-pages-simple-editor">
                    <div className="admin-pages-simple-toolbar">
                        <button type="button" onClick={() => applySimpleTextFormat(index, "paragraph")}>Parrafo</button>
                        <button type="button" onClick={() => applySimpleTextFormat(index, "bold")}><strong>B</strong></button>
                        <button type="button" onClick={() => applySimpleTextFormat(index, "italic")}><em>I</em></button>
                        <button type="button" onClick={() => applySimpleTextFormat(index, "list")}>• Lista</button>
                    </div>
                    <InputTextarea
                        className="admin-pages-field"
                        ref={(element) => setTextEditorRef(index, element)}
                        value={section.paragraphsText || ""}
                        onChange={(event) => updateSection(index, { paragraphsText: event.target.value })}
                    />
                </div>
                <small>Selecciona texto y usa B, I o Lista. Para listas se agrega "- " automaticamente.</small>
            </div>
        ) : null}

        {structuredConfig ? (
            <StructuredSectionEditor
                section={section}
                sectionIndex={index}
                config={structuredConfig}
                entries={structuredEntries}
                updateSection={updateSection}
                addStructuredLine={addStructuredLine}
                editStructuredLine={editStructuredLine}
                cancelEdit={cancelEdit}
                removeStructuredLine={removeStructuredLine}
                editingIndex={editingIndex}
            />
        ) : null}

        {section.type === "franja" ? (
            <>
                <div className="admin-pages-row">
                    <label>Titulo de la franja</label>
                    <InputText className="admin-pages-field" value={section.title || ""} onChange={(event) => updateSection(index, { title: event.target.value })} placeholder="Texto sobre la imagen" />
                </div>
                <div className="admin-pages-row">
                    <label>Imagen de fondo</label>
                    <InputText className="admin-pages-field" value={section.backgroundImage || ""} onChange={(event) => updateSection(index, { backgroundImage: event.target.value })} placeholder="https://..." />
                    <small className="admin-sidebar-hint admin-text-xs">
                        <i className="pi pi-info-circle" /> Sugerencia: 1920×100px (relación ~19:1). Franja horizontal delgada, la imagen se recorta a 50px de alto.
                    </small>
                </div>
                <div className="admin-pages-row">
                    <label>URL de redireccion</label>
                    <InputText className="admin-pages-field" value={section.href || ""} onChange={(event) => updateSection(index, { href: event.target.value })} placeholder="https://..." />
                </div>
            </>
        ) : null}

        {section.type === "bloqueComercial" ? (
            <>
                <div className="admin-pages-row">
                    <label>Imagen izquierda</label>
                    <InputText className="admin-pages-field" value={section.imageLeft || ""} onChange={(event) => updateSection(index, { imageLeft: event.target.value })} placeholder="https://..." />
                    <small className="admin-sidebar-hint admin-text-xs">
                        <i className="pi pi-info-circle" /> Sugerencia: 960×620px (relación 960:620 ≈ 1.55:1).
                    </small>
                </div>
                <div className="admin-pages-row">
                    <label>URL columna izquierda</label>
                    <InputText className="admin-pages-field" value={section.toLeft || ""} onChange={(event) => updateSection(index, { toLeft: event.target.value })} placeholder="https://..." />
                </div>
                <div className="admin-pages-row">
                    <label>Imagen derecha</label>
                    <InputText className="admin-pages-field" value={section.imageRight || ""} onChange={(event) => updateSection(index, { imageRight: event.target.value })} placeholder="https://..." />
                    <small className="admin-sidebar-hint admin-text-xs">
                        <i className="pi pi-info-circle" /> Sugerencia: 960×620px (relación 960:620 ≈ 1.55:1).
                    </small>
                </div>
                <div className="admin-pages-row">
                    <label>URL columna derecha</label>
                    <InputText className="admin-pages-field" value={section.toRight || ""} onChange={(event) => updateSection(index, { toRight: event.target.value })} placeholder="https://..." />
                </div>
            </>
        ) : null}
        </div>
    </article>
    );
};

export default SectionEditorCard;
